import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBadge() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (online) return null;

  return (
    <div
      className="fixed z-40 flex items-center gap-1.5 fade-in"
      style={{
        top: "max(env(safe-area-inset-top), 12px)",
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgba(26,26,26,0.92)",
        color: "#fff",
        padding: "6px 12px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 600,
        boxShadow: "0 8px 20px -8px rgba(0,0,0,0.35)",
      }}
      data-testid="offline-badge"
    >
      <WifiOff size={13} color="var(--sm-rose)" /> Offline mode
    </div>
  );
}
